<!--
 * @Author: your name
 * @Date: 2021-03-23 15:33:03
 * @LastEditTime: 2021-03-23 15:35:47
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \backStage_mana\src\components\BaseDialog.vue
-->
<template>
  <div class="base-dialog">
    <el-dialog v-bind="$attrs" v-on="$listeners" :width="width">
      <slot></slot>
      <slot name="footer" slot="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'baseDialog',
  components: {
  },
  props: {
    size: {
      type: String,
      default: 'big',
      validator (val) {
        return ['big', 'small'].indexOf(val) !== -1
      },
    },
  },
  computed: {
    width () {
      return this.size === 'big' ? '960px' : '640px'
    },
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
    this.$nextTick(() => {
      document.querySelector('.el-dialog').style.height = this.size === 'big' ? '640px' : '480px'
    })
  },
}
</script>

<style lang="less" scoped>
// @import '../assets/static/style/common.less';

.base-dialog {
  /deep/ .el-dialog{
    .el-dialog__header{
      padding: 0px;
      height: 40px;
      line-height: 40px;
      background-color: #272d32;
      .el-dialog__title{
        margin-left: 25px;
        color: #fff;
        font-size: 15px;
      }
    }
    .el-dialog__headerbtn{
      top: 6px;
      .el-dialog__close{
        color: #fff;
        font-size: 30px;
      }
    }
    .el-dialog__body{
      padding: 0;
      font-size: 15px;
    }
  }
}
</style>
